module.exports = __webpack_public_path__ + "img/deleted-user-avatar.badad2c1.png";